import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import {CommonResponse} from '../interfaces/home';

@Injectable({
  providedIn: 'root'
})
export class ServiceTypeService {
  constructor(private http: HttpClient) { }
  baseUrl = environment.baseUrl+'ServiceType/';
  // fetch all ServiceType in the database
  allData(): Observable<CommonResponse>{
    return this.http.get<CommonResponse>(this.baseUrl);
  }
  getServiceType(id: any):Observable<CommonResponse>{
    return this.http.get<CommonResponse>(this.baseUrl +id);
  }
  getServiceTypeByName(name: any):Observable<CommonResponse>{
    return this.http.get<CommonResponse>(this.baseUrl + 'name/' + name);
  }
  postServiceType(data: any){
    return this.http.post(this.baseUrl, data);
  }
  deleteServiceType(id: any){
    return this.http.delete(this.baseUrl +id);
  }
  updateServiceType(id: any, data: any){
    return this.http.put(this.baseUrl +id, data);
  }
}
